import IframeWrapper from '../../components/backoffice/iframe-wrapper';
import { useEffect } from 'react';
import { allowedOrigins } from '../../helpers/securityHelper';
import { useNavigate } from 'react-router-dom';

export default function Partners() {
	const navigate = useNavigate();
	useEffect(() => {
		const handleMessage = (event: MessageEvent) => {
			if (!allowedOrigins.includes(event.origin)) {
				return;
			}

			const { type } = event.data;
			if (type === 'redirect') {
				const { url } = event.data;
				navigate(url);
			}
		};

		window.addEventListener('message', handleMessage);

		return () => {
			window.removeEventListener('message', handleMessage);
		};
	}, [navigate]);

	return <IframeWrapper id='iframe-partners' path='/shared/nuqlea-studio/partners' />;
}
